import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'
import { DEV_OR_LOCALHOST } from '@bases/base.token'
import { FEEDBACK } from '@core/constants/constant.data'
import { environment } from '@env/environment'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'htm-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss'],
  imports: [
    // Material
    MatButtonModule,
    MatIconModule,
  ],
})
export class WelcomePageComponent {
  devOrLocalhost = inject<BehaviorSubject<string>>(DEV_OR_LOCALHOST)
  private readonly _router = inject(Router)

  feedback = FEEDBACK
  appName = environment.appName
  logoUrl = environment.logoUrl
  partnersLogosUrl = environment.partnersLogosUrl
  introText = environment.introText
  feedbackText = environment.feedbackText
  websiteUrl = environment.websiteUrl
  wikiUrl = environment.wikiUrl
  repositoryUrl = environment.repositoryUrl
  dataSetURl = environment.dataSetURl
  fundingText = environment.fundingText
  fundingImg = environment.fundingImg

  setProjectInfoClose() {
    if (this._router.url !== 'map') {
      this._router.navigate(['map'])
    }
  }
}
